import styled from 'styled-components';

export const Container = styled.div`
	background-image: url('https://lh4.googleusercontent.com/proxy/uC6FALkgFwmKIL0T8MIWmjFvSMehz_Pp33FOEed1f3cm_H-OjTmWdvBM1uq1j0T2_mhFV-dm0oKYjv1rBw');
	background-position: 50%;
	background-size: cover;
	height: 100vh;
	width: 100vw;
	position: fixed;
	top: 0;
	left: 0;
	overflow-y: scroll;
`;



export const Title = styled.h1`
	cursor: default;
	font-weight: 400;
	font-size: 1.5rem;
	text-align: center;
	width: 100vw;
	margin-bottom: 1rem;
	color: lightblue;
	text-shadow: 3px 0px 7px rgba(81, 67, 21, 0.8), -3px 0px 7px rgba(81, 67, 21, 0.8),
		0px 4px 7px rgba(81, 67, 21, 0.8);
	user-select: none;
`;

export const Wrapper = styled.div`
	margin-top: 6rem;
	width: 100%;
	padding: 1rem;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	align-content: flex-start;
	overflow-y: auto;
`;

export const Board = styled.div`
	color: white;
	padding: 0.6rem;
	margin: 0 0.8rem 1rem 0.8rem;
	width: 300px;
	height: 140px;
	border-radius: 15px;
	${(props) =>
		props.isImage ? 'background-image: url(' + props.link + ');' : 'background-color: ' + props.link + ';'}

	background-position: center center;
	background-size: cover;
	-webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
	-moz-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
    box-shadow: rgb(255 255 255 / 40%) 1px 0px 8px 3px;
    opacity: 85%;
	cursor: pointer;
	will-change: opacity;
	transition: opacity .5s;
	&:hover {
		opacity: 100%;
			transition: 400ms ease-in;

		font-weight: 600;
		scale:1.1
		
	}
`;

export const AddBoard = styled(Board)`
	background-color: transparent;
	background-image: linear-gradient(to right,rgb(136, 136, 136) 0%,rgb(197, 193, 193) 51%,rgb(130, 130, 130) 100%);
	font-size: 1.2rem;
	transition: 2s;
	opacity: 100%;
	background-size: 200% auto;
	color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	font-weight: 600;
	&:hover {
		background-position: right center;
		color: #fff;
		transition: 400ms ease-in;
	}
`;
